import { render, staticRenderFns } from "./simDataLogo.vue?vue&type=template&id=5ead21bb&scoped=true&"
import script from "./simDataLogo.vue?vue&type=script&lang=js&"
export * from "./simDataLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ead21bb",
  null
  
)

export default component.exports